import { useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "configureStore";
import { Button, InlineStack, Banner } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import { setDestroy, setIsModalxOpen } from "components/modalx/modalx.slice";
import { useParams } from "react-router-dom";
import { assetForceReturn } from "services/assets.service";
import { refreshAsset } from "containers/assets/assets.slice";
import { fetchAssetDetails } from "containers/asset-view-container/asset-container.slice";

interface ConfirmModalProps {
  id: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ id }) => {
  const dispatch: AppDispatch = useDispatch();
  const { t } = useTranslation();
  const { companyId } = useParams();

  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errMsg, setErrMsg] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleToInstockAsset = async () => {
    try {
      setIsLoading(true);
      await assetForceReturn(companyId, id);
      if (companyId && id) {
        // Refresh just this row in place (return changes status/assignment)
        // without resetting loaded pages or scroll position.
        dispatch(refreshAsset(companyId, id));
        dispatch(fetchAssetDetails({ companyId, id }));
      }
      setSuccessMessage("ok");
      setIsLoading(false);
      closeModal();
    } catch (e) {
      setErrMsg("error");
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    dispatch(setIsModalxOpen(false));
    dispatch(setDestroy());
  };

  return (
    <>
      <div className="form-warnings">
        {errMsg && (
          <div>
            <Banner tone="critical">{t(errMsg)}</Banner>
          </div>
        )}
        {successMessage && (
          <div>
            <Banner tone="info">{t(successMessage)}</Banner>
          </div>
        )}
      </div>
      <h1 style={{ textAlign: "center" }}>
        {t("are_you_sure_you_want_in_stock_asset")}
      </h1>

      <InlineStack align="space-between">
        <Button onClick={handleToInstockAsset} loading={isLoading}>
          {t("Yes")}
        </Button>

        <Button onClick={closeModal} disabled={isLoading}>
          {t("No")}
        </Button>
      </InlineStack>
    </>
  );
};

export default ConfirmModal;
